import { Badge } from '@chakra-ui/react';
import { memo } from 'react';

import { PAYMENT_REQUEST_STATUS_META } from '@features/finance/financeMeta';
import type { PaymentRequestStatus } from 'helpers/fakeData';

interface Props {
  status: PaymentRequestStatus;
}

const PaymentRequestStatusBadge = memo(({ status }: Props) => {
  const meta = PAYMENT_REQUEST_STATUS_META[status];
  return (
    <Badge size="xs" colorPalette={meta.palette} variant="subtle" borderRadius="full">
      {meta.label}
    </Badge>
  );
});
PaymentRequestStatusBadge.displayName = 'PaymentRequestStatusBadge';

export default PaymentRequestStatusBadge;
